// src/components/LiveChart.jsx
import React, { useEffect, useState } from "react";

const LiveChart = () => {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setOffset((prev) => (prev + 10) % 600);
    }, 300);
    return () => clearInterval(interval);
  }, []);

  return (
    <svg width="100%" height="120" viewBox="0 0 600 120">
      <polyline
        fill="none"
        stroke="#ff1744"
        strokeWidth="2"
        points={`
          ${offset},60 ${offset + 40},60 ${offset + 60},20 ${offset + 80},100 ${offset + 100},60
        `}
      />
    </svg>
  );
};

export default LiveChart;
